import React from 'react';
import { AvatarGroup, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/** Компонент с опциями тарифа (набор иконок и заголовок) */
export var Options = function Options(_ref) {
  var title = _ref.title,
    icons = _ref.icons;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('options'),
    "data-t-id": "components-Options"
  }, title && /*#__PURE__*/React.createElement(Text, {
    color: "secondary-invert",
    size: "xs"
  }, title), /*#__PURE__*/React.createElement(AvatarGroup, {
    className: cx('options__group'),
    items: icons,
    size: "s",
    visibleCount: 10
  }));
};